import { itemsService } from '../services'

export default (clClientId, tipo, periodicity) => {
	return new Promise((resolve) => {
		itemsService.savePeriodicity(clClientId, tipo, periodicity)
			.then(response => resolve(response))
	})
}
